export default __webpack_public_path__ + "static/media/loader.63571e85.gif";